import type { SVGProps } from 'react';
const SvgSettings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <g
      clipPath="url(#Settings_svg__a)"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    >
      <path d="M7.094 2.048a1.22 1.22 0 0 0 1.81 0l.59-.646a1.22 1.22 0 0 1 2.122.88l-.044.871a1.22 1.22 0 0 0 1.277 1.28l.871-.045a1.22 1.22 0 0 1 .878 2.123l-.649.585a1.22 1.22 0 0 0 0 1.811l.65.586a1.22 1.22 0 0 1-.88 2.123l-.872-.044a1.22 1.22 0 0 0-1.28 1.28l.044.871a1.22 1.22 0 0 1-2.117.878l-.586-.648a1.22 1.22 0 0 0-1.81 0l-.589.648a1.22 1.22 0 0 1-2.12-.876l.045-.872a1.22 1.22 0 0 0-1.28-1.28l-.872.044a1.219 1.219 0 0 1-.881-2.121l.648-.585a1.22 1.22 0 0 0 0-1.812l-.648-.588a1.22 1.22 0 0 1 .877-2.12l.872.044a1.22 1.22 0 0 0 1.28-1.283L4.39 2.28a1.22 1.22 0 0 1 2.12-.878z" />
      <path d="M5 8a3 3 0 1 0 6 0 3 3 0 0 0-6 0" />
    </g>
    <defs>
      <clipPath id="Settings_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSettings;
